import { SearchService } from '@core/services';
import { OiqFormSearchProvider } from '@oiq-ui-sdk/form';
import { Observable, of } from 'rxjs';

export const OIQ_NOTIFICATION_ENTITY_TYPES = [
  {
    name: 'Clients',
    value: 'clients',
    overview: 'overview',
    isSelectOption: true,
  },
  {
    name: 'Syndicators',
    value: 'syndicators',
    overview: 'overview',
    isSelectOption: true,
  },
  {
    name: 'ISOS',
    value: 'isos',
    overview: 'general-info',
    isSelectOption: true,
  },
  {
    name: 'Law Firms',
    value: 'law-firms',
    overview: 'general-info',
    isSelectOption: true,
  },
];

export const OIQ_NOTIFICATION_REMINDER_INTERVALS = [
  { name: '- Select -', value: 0 },
  { name: '15m before', value: 15 },
  { name: '30m before', value: 30 },
  { name: '1h before', value: 60 },
  { name: '6h before', value: 360 },
  { name: '12h before', value: 720 },
  { name: '24h before', value: 1400 },
];

export class OiqNotificationEntitySearchStore extends OiqFormSearchProvider<any> {
  private _type: string;
  public get type(): string {
    return this._type;
  }
  public set type(v: string) {
    this._type = v;
  }

  constructor(private searchService: SearchService) {
    super();
  }

  search(term: string): Observable<any[]> {
    switch (this.type) {
      case 'clients':
        return this.searchService.performClientsTypeahead(term);
      case 'syndicators':
        return this.searchService.performSyndicatorsTypeahead(term) as Observable<any[]>;
      case 'isos':
        return this.searchService.performIsosTypeahead(term) as Observable<any[]>;
      case 'law-firms':
        return this.searchService.performLawFirmsTypeahead(term) as Observable<any[]>;
      default:
        return of([]);
    }
  }

  public entityData: any = null;

  read(identity: any) {
    return of(this.entityData);
  }

  getItemText(item: any): string {
    return item.name;
  }
}
